import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import SFLink from "../../../link";
import SFTypography from "../../../typography";

// import { Link } from "@mui/material";

const SFURLRenderer = ({ context, data, value, column, colDef, ...props }) => {
  const LinkBehavior = React.forwardRef((props, ref) => (
    <NavLink ref={ref} to={props.to} {...props}>
      {props.children}
    </NavLink>
  ));

  if (!context.viewDetailsUrl)
    return <SFTypography variant="tableList">{value}</SFTypography>;
  return (
    context.viewDetailsUrl && (
      <SFTypography variant="tableList">
        <SFLink
          to={`${context.viewDetailsUrl}/${data.id}`}
          component={LinkBehavior}
          variant={colDef.variant ?? colDef.context?.variant ?? "gridUrlRender"}
        >
          {value}
        </SFLink>
      </SFTypography>
    )
  );
};

SFURLRenderer.propTypes = {
  value: PropTypes.any,
  variant: PropTypes.string,
  column: PropTypes.any,
};

export default SFURLRenderer;
